import React from 'react';

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.142 5.392c.19-.19.498-.19.688 0l4.17 4.17 4.17-4.17c.19-.19.498-.19.688 0s.19.498 0 .688l-4.514 4.514c-.19.19-.498.19-.688 0l-4.514-4.514c-.19-.19-.19-.498 0-.688",
    clipRule: "evenodd"
  }));
};
SvgChevronDown.displayName = "ChevronDown";

export { SvgChevronDown as S };
